export default __webpack_public_path__ + "static/media/au.fd86b723.svg";